module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-rtu-permalip_3_after.jpg
// module id = 1377
// module chunks = 0